//Simple Filter Toggle Function for Collection. 
function FilterToggle() {
  let filterButton = document.querySelector(".filters-button");
  let collectionContainer = document.querySelector("#CollectionAjaxContent");

  if (filterButton != null) {
  filterButton.addEventListener("click", () => {
    collectionContainer.classList.toggle("filters-active");
    filterButton.classList.toggle("is-active");
    filterButton.scrollIntoView({ behavior: "smooth" });
  });
  }
}
FilterToggle();

var fshipTextContainer = document.querySelectorAll('.shipDetails');
fshipTextContainer.forEach(element => {
  element.onclick = function() {
    event.preventDefault()
    modal.style.display = "block";
  }
});

// Get the modal
var modal = document.getElementById("myModal"),

// Get the button that opens the modal
 btn = document.getElementsByClassName("shipDetails"),

// Get the <span> element that closes the modal
 span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 

/* btn.style.background = "red"; */

btn.onclick = function() {
  /* event.preventDefault()
  modal.style.display = "block"; */
  btn.style.background = "red";
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

document.addEventListener('collection:reloaded', function() {
    FilterToggle();
    const fButton = document.querySelector(".filters-button");
    fButton.classList.add('is-active');
});

// GIFT SHIP CUSTOM CODE
(() => {
  const MODULE = (() => {
      let initialized = false;
      let drawer = null;

      const init = () => {
          if (initialized) return;
          registerElements();
          registerEventHandlers();
          initialized = true;
      };

      const registerElements = () => {
          drawer = document.getElementById('gsDrawer');
      };

      const registerEventHandlers = () => {
          document.addEventListener('keydown', handleKeydown);
          document.addEventListener('focus', handleFocus, true);

          document.addEventListener('giftship.drawer-cart.closed', handleDrawerClosed);
          document.addEventListener('giftship.drawer-cart.opened', handleDrawerOpened);
      };

      const handleKeydown = (event) => {
          if (event.key === 'Enter') {
             document.activeElement.blur();
             event.preventDefault();
          }
      };

      const handleFocus = (event) => {
          if (event.target.type === 'number') event.target.select(); 
      };

      const handleDrawerClosed = () => cleanupEventListeners();

      const handleDrawerOpened = () => {
          cleanupEventListeners();
          registerEventHandlers();
      };

      const cleanupEventListeners = () => {
          document.removeEventListener('keydown', handleKeydown);
          document.removeEventListener('focus', handleFocus, true);
      };

      return { init };
  })();

  MODULE.init();
})();


/* async function getData() {
  const url = "https://christmastraditions.com/cart/update.js";
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    console.log(json);
    alert('crap ! json');
  } catch (error) {
    console.error(error.message);
  }
} */



/* THIS IS NOW LOCATED DIRECTLY WITHIN theme.js  */
/* document.addEventListener('cart:updated', function(evt) {
  var cartTotal = ("$" + evt.detail.cart.total_price / 100);
  var percentage = Math.round(evt.detail.cart.total_price / 150);
  var FSHIPamount = ("$" + ((15000 - evt.detail.cart.total_price) / 100));
  var FSHIPcontainer = document.querySelector("#freeShippingAmount");
  var freeShipSlider = document.querySelector("#freeShipSlider");
  var fship_below = document.querySelector(".fship_below");
  var fship_above = document.querySelector(".fship_above");

  //console.log(evt.detail.cart);
  FSHIPcontainer.innerHTML = (FSHIPamount);
  freeShipSlider.style.width = (percentage + "%");
  
  if (evt.detail.cart.total_price > 15000) {
    fship_below.style.display = "none";
    fship_above.style.display = "block";
  } else {   
    fship_below.style.display = "block";
    fship_above.style.display = "none";
  }

  //alert("This is the cart total " + cartTotal + ". Amount to Free Shipping: " + FSHIPamount + " and the percent to free ship is " + percentage);
}); */

/* document.addEventListener('ajaxProduct:added', function(evt) {
  console.log(evt.detail.product);
  console.log(evt.detail.cart);

  // if addToCartBtn is returned, product was added by quick add feature
  if (evt.detail.addToCartBtn) {
    console.log(evt.detail.addToCartBtn);
  }
});
 */